import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Typography, Box } from '@mui/material';
import Breadcrumb from 'src/components/Breadcrumb';
import { useDispatch } from 'react-redux';
import DownloadButton from 'src/components/DownloadButton';
import {
  downloadWithholdings,
  loadWithdolgins
} from 'src/store/actions/cfdiActions';

import TimePeriod from 'src/utils/TimePeriod';
import { CLEAR_CFDIS_OPTIONS } from 'src/store/constants/CFDI';
import useStyles from './styles';

const Toolbar = ({ className, ...rest }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      loadWithdolgins({
        period: TimePeriod.MONTH
      })
    );

    return () => {
      dispatch({ type: CLEAR_CFDIS_OPTIONS });
    };
  }, []);

  return (
    <>
      <Box className={clsx(classes.root, className)} {...rest}>
        <Breadcrumb doNotRedirectIndexList={[0, 1]} />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Box>
            <Typography
              style={{ fontWeight: '400' }}
              color="primary"
              variant="h1"
            >
              {t('NAVIGATION.WITHHOLDINGS')}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '30%',
                marginRight: '20px'
              }}
            >
              <DownloadButton
                onDownload={() => {
                  dispatch(downloadWithholdings());
                }}
                title="COMMON.DOWNLOAD_WIHHOLDINGS"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
